import moment from 'moment';
import { dateFormatting } from './apiHelper';

export const getOwnerIds = (
  selectedOwners,
  ownerlist = [],
  myTeam = []
) => {
  if (!Array.isArray(selectedOwners) || selectedOwners.length === 0) {
    return [];
  }

const ids = selectedOwners.flatMap(({ id }) => {
  if (id === "COMMON_ENTIRE_ORG") return ownerlist.map(o => o.id);
  if (id === "COMMON_MY_TEAM") return myTeam.map(o => o.id);
  return id ? [id] : [];
});

  return [...new Set(ids)];
};


export const resolveOwnerIds = ({ isEntireOrg, allOwnerIds, reportingTeamIds, currentUserId }) => {
    if (isEntireOrg) return allOwnerIds;
    if (reportingTeamIds?.length === 0) return currentUserId;
    return reportingTeamIds;
};


export const buildChartQueryParams = (ownerIds, days) => {
    return {
        ownerIds,
        updatedFrom: dateFormatting(moment().subtract(days, 'days')),
        updatedTo: dateFormatting(moment()),
    };
};
